const initialWorkflowDetails= 
{ 
userName:"",
userId:"",
data:{}
};       
export default function GetTokenReducer(workflowDetails = initialWorkflowDetails, action) 
{
switch (action.type) {
    case "UPDATE_USER_NAME":
    return {
      ...workflowDetails,
      userName:action.payload
    }
    case "UPDATE_USER_ID":
    return {
      ...workflowDetails,
      userId:action.payload
    }
      case "UPDATE_DATA":
      return {
        ...workflowDetails,
        data:action.payload
      }
  default:
    return workflowDetails;
 }
}